/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, memo, useEffect } from 'react';

import { Text, Space, Conditional, Button } from '@cashfree-intl/coherent';

import { formatStringForDisplay, scrollToTop } from 'utils/common';
import { DEFAULT_DATE_OPTIONS } from 'utils/constants';

import DashboardFilters from '../../DashboardFilters';

import {
  DashboardFiltersComponentProps,
  ITDRListPerPaymentMethodProps,
} from '../types';

import { ALL_TIME_DATE_FILTER } from '../constants';

import PaymentMethodRateTable from './PaymentMethodRateTable';
import PaymentMethodRateTableV2 from './PaymentMethodRateTableV2';

const DashboardFiltersComponent: React.FC<
  DashboardFiltersComponentProps
> = props => <DashboardFilters {...props} />;

const TDRListPerPaymentMethod = ({
  filters,
  filtersForDisplay,
  paymentMode,
  resetPage,
  resetFilters,
  updateFilters,
  setFormData,
  rowData,
  formData,
  totalPages,
  totalCount,
  onExternalPMRToggle,
  onExternalPMREdit,
  showSlabs,
  isLoading,
}: ITDRListPerPaymentMethodProps) => {
  const [isTotalActive, setTotalActive] = useState(false);
  const [selected, setSelected] = useState({});

  const onUpdateClick = () => {
    const result: any[] = [];
    // here we have to pick the data from the rowData
    Object.keys(selected).forEach(key => {
      // only for selected -> true
      if (selected[key]) {
        const data = rowData.find(obj => obj.id === key);
        if (data) result.push(data);
      }
    });
    // console.log('update button clicked - ', result);
    setFormData(result);
    scrollToTop('.children-wrapper');
  };

  useEffect(() => {
    // on Edit save update the setSelected to {}
    if (formData && formData.length === 0) {
      setSelected({});
    }
  }, [formData]);

  const onPageChange = type => {
    const { pageNo } = filters;
    let result = pageNo;
    switch (type) {
      case 'NEXT':
        result = pageNo + 1;
        break;
      case 'PREV':
        result = pageNo - 1;
        break;
      default:
    }
    updateFilters({ ...filters, pageNo: result });
  };

  const onLimitChange = (e, data) => {
    updateFilters({ ...filters, pageNo: 1, pageSize: +data.value });
  };

  // pagination info
  const currentPageCount = rowData.length;
  const primaryKey = 'id';

  const hasPrev = filters.pageNo !== 1;
  const hasNext = filters.pageNo !== totalPages;

  const selectProps = {
    isTotalActive,
    setTotalActive,
    selected,
    setSelected,
    entity: 'upfrontTdr',
  };

  const highlightRow = formData && formData.length === 1 && formData[0].id;

  return (
    <div>
      <Text variant="b14" strong className="mb-3">
        All Upfront TDRs on {formatStringForDisplay(paymentMode)}
      </Text>
      <Space alignItems="center" justifyContent="space-between">
        <DashboardFiltersComponent
          menuSelected="ROUTER"
          filters={filters}
          filtersForDisplay={filtersForDisplay}
          activeNavigation="UPFRONT_TDR"
          resetFilterFn={resetFilters}
          resetPageFn={resetPage}
          updateFilterFn={updateFilters}
          dateOptions={[{ ...ALL_TIME_DATE_FILTER }, ...DEFAULT_DATE_OPTIONS]}
        />
        <Conditional if={Object.keys(selected).some(key => !!selected[key])}>
          <Button
            primary
            onClick={onUpdateClick}
            data-event-name="Primary_Button_Update"
            data-ignore-inner-text="true"
          >
            Update {Object.keys(selected).filter(key => !!selected[key]).length}{' '}
            Items
          </Button>
        </Conditional>
      </Space>
      {showSlabs ? (
        <PaymentMethodRateTableV2
          filters={filters}
          hasPrev={hasPrev}
          hasNext={hasNext}
          currentPageCount={currentPageCount}
          totalCount={totalCount}
          onPageChange={onPageChange}
          onLimitChange={onLimitChange}
          rowData={rowData}
          selectProps={selectProps}
          primaryKey={primaryKey}
          highlightRow={highlightRow}
          selected={selected}
          onExternalPMREdit={onExternalPMREdit}
          onExternalPMRToggle={onExternalPMRToggle}
          isTotalActive={isTotalActive}
          onUpdateClick={onUpdateClick}
          isLoading={isLoading}
        />
      ) : (
        <PaymentMethodRateTable
          filters={filters}
          hasPrev={hasPrev}
          hasNext={hasNext}
          currentPageCount={currentPageCount}
          totalCount={totalCount}
          onPageChange={onPageChange}
          onLimitChange={onLimitChange}
          rowData={rowData}
          selectProps={selectProps}
          primaryKey={primaryKey}
          highlightRow={highlightRow}
          selected={selected}
          isTotalActive={isTotalActive}
          onUpdateClick={onUpdateClick}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};

export default memo(TDRListPerPaymentMethod);
